/**
 * Converts a hex UUID string to its BigInt representation as a string.
 */
export const hexUUIDToBigInt = (uuidStr: string): string => {
    const hex = uuidStr.replace(/-/g, '');
    return BigInt(`0x${hex}`).toString();
};
